import styled from 'styled-components'

export const SelectGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Item = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
`

export const Name = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  font-size: 1.25rem;
  font-weight: 450;
`

export const Description = styled.div`
  padding-top: 7px;
  padding-left: 26px;
`

export const Prices = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  padding-top: 10px;

  font-weight: 450;
`

export const PriceCity = styled.div``

export const Price = styled.div``

export const Radio = styled.input`
  & .ant-radio-label label {
    font-size: 1.25rem;
  }
`
